<template>
  <div><pageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-workshop',
  components: { PageTable },
}
</script>
